import * as React from "react"
import { Eye, EyeOff } from "lucide-react"
import { Input } from "./input";
import { cn } from "../../lib/utils";

function Password({ className, type, ...props }: React.ComponentProps<"input">) {
  const [inputType, setInputType] = React.useState(type);

  const toggleInputType = () => {
    setInputType(inputType === 'password' ? 'text' : 'password')
  }
  return (<span className={cn("flex items-center gap-2", className)}>
    <Input
      type={inputType}
      className="flex-1 outline-none border-none bg-transparent pl-0"
      {...props}
    />
    {inputType === 'password'
      ? <EyeOff size={20} className="cursor-pointer mr-3" onClick={toggleInputType} />
      : <Eye size={20} className="cursor-pointer mr-3" onClick={toggleInputType} /> }
  </span>
  )
}

export { Password };
